var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.612 20a.588.588 0 01-.433-.195.698.698 0 01-.179-.472V4.667c0-.116.028-.23.08-.33a.643.643 0 01.22-.244.576.576 0 01.608-.01l12.249 7.333a.64.64 0 01.232.245.711.711 0 010 .678.64.64 0 01-.232.245l-12.25 7.333a.573.573 0 01-.295.083z",
    fill: "currentColor"
  })));
}
export default SvgPlay;